import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import PasswordInput from '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import { runningInApp } from '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import { getErrorMessage } from '../Rssi/errorHandler.js';
import styles from './AccessToken.module.scss.js';
import { requestSmsTokenAsync, userPasswordValidationAsync } from './accessTokenSlice.js';

var PasswordStep = function PasswordStep(_ref) {
  var setUserPassword = _ref.setUserPassword,
    userPassword = _ref.userPassword,
    setSmsSent = _ref.setSmsSent,
    openForgotPasswordModal = _ref.openForgotPasswordModal,
    client = _ref.client;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setIsLoading = _useState4[1];
  var handlePasswordValidate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var validPassword, _getErrorMessage, description, _getErrorMessage2, _description;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setError(null);
              setIsLoading(true);
              _context.prev = 2;
              _context.next = 5;
              return userPasswordValidationAsync(userPassword, client);
            case 5:
              validPassword = _context.sent;
              if (!validPassword) {
                _context.next = 19;
                break;
              }
              _context.prev = 7;
              _context.next = 10;
              return requestSmsTokenAsync(client);
            case 10:
              setSmsSent(true);
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              _getErrorMessage = getErrorMessage()(_context.t0), description = _getErrorMessage.description;
              setError(description);
            case 17:
              _context.next = 20;
              break;
            case 19:
              setError(t('MPLIB_INCORRECT_PASSWORD'));
            case 20:
              setIsLoading(false);
              _context.next = 28;
              break;
            case 23:
              _context.prev = 23;
              _context.t1 = _context["catch"](2);
              _getErrorMessage2 = getErrorMessage()(_context.t1), _description = _getErrorMessage2.description;
              setError(_description);
              setIsLoading(false);
            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 23], [7, 13]]);
    }));
    return function handlePasswordValidate() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleEnterKey = function handleEnterKey(event) {
    if (event.key === 'Enter' && !error) {
      if (userPassword && !loading) {
        handlePasswordValidate();
      }
    }
  };
  useEffect(function () {
    document.addEventListener('keydown', handleEnterKey, {
      once: true
    });
    return function () {
      return document.removeEventListener('keydown', handleEnterKey);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.intro
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.introTitle
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-smartphone",
    size: "medium",
    className: styles.icon
  }), t("MPLIB_ACCESS_TOKEN_TITLE")), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t("MPLIB_ACCESS_TOKEN_DESCRIPTION")), /*#__PURE__*/React.createElement("div", {
    className: styles.introTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.number
  }, /*#__PURE__*/React.createElement("p", null, "1")), t("MPLIB_ACCESS_TOKEN_STEP_1")), /*#__PURE__*/React.createElement(PasswordInput, {
    onChange: function onChange(value) {
      return setUserPassword(value);
    },
    placeholder: t("MPLIB_LOGINPASSWORD_TITLE"),
    value: userPassword,
    type: "password",
    dataTestId: "passwordInput",
    className: styles.passwordInput,
    maxLength: 30,
    autoComplete: "current-password",
    focusAndScrollIntoView: runningInApp
  }), error && /*#__PURE__*/React.createElement("p", {
    className: styles.passwordError
  }, error), /*#__PURE__*/React.createElement(Button, {
    text: t("MPLIB_SEND_SMS"),
    onClick: handlePasswordValidate,
    disabled: !userPassword || loading,
    dataTestId: "passwordButton",
    className: styles.passwordButton,
    red: true,
    isLoading: loading
  }), runningInApp && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: openForgotPasswordModal,
    className: styles.forgotLink
  }, t("MPLIB_ACCESS_TOKEN_FORGOT_PASSWORD"))));
};
PasswordStep.propTypes = {
  setUserPassword: PropTypes.func.isRequired,
  userPassword: PropTypes.string.isRequired,
  setSmsSent: PropTypes.func.isRequired,
  openForgotPasswordModal: PropTypes.func.isRequired,
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired
  }).isRequired
};

export { PasswordStep as default };
